import { render, staticRenderFns } from "./view-on-board.vue?vue&type=template&id=03a6b8d5"
import script from "./view-on-board.vue?vue&type=script&lang=js"
export * from "./view-on-board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports